import ApolloClient from "apollo-boost"
import fetch from "isomorphic-fetch"

export const client = new ApolloClient({
  uri: "https://z1puyl5f7c.execute-api.us-east-1.amazonaws.com/dev/graphql",
  fetch,
})
